/**
 * Validate file size
 * @param {File} file
 * @param {number} maxSizeMB - max size in MB
 * @returns {boolean}
 */
export const isValidFileSize = (file: File, maxSizeMB: number) => {
  const maxSizeBytes = maxSizeMB * 1024 * 1024;
  return file.size <= maxSizeBytes;
};
